import { render, staticRenderFns } from "./GroupOrderByMonth.vue?vue&type=template&id=522b1c9c&scoped=true"
import script from "./GroupOrderByMonth.vue?vue&type=script&lang=js"
export * from "./GroupOrderByMonth.vue?vue&type=script&lang=js"
import style0 from "./GroupOrderByMonth.vue?vue&type=style&index=0&id=522b1c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b1c9c",
  null
  
)

export default component.exports